import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as Upload } from '../../assets/images/svg/upload.svg';
import themeColors from '../../assets/styles/themeColors';

const UploadIconStyled = styled(Upload)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};

  #Icons {
    fill: ${({ color }) => color || themeColors.colorTextSecondary};
  }
`;

const UploadIcon = (props) => <UploadIconStyled {...props} />;

UploadIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

UploadIcon.defaultProps = {
  w: '25px',
  h: '25px',
};

export default UploadIcon;
